/**
 * The save panel's stylesheet, injected with the panel and removed with it.
 *
 * Quieter than a mode card and louder than the name row: this is not the reason anyone opened the
 * game, but losing a character is the reason they will wish they had found it. Amber marks the
 * confirm, red the refusal, green the write that landed, and the status line is the only thing
 * here that changes colour, because it is the only thing here that carries news.
 *
 * No frame of its own any more. Two buttons and a hint under the name row read as part of that row;
 * a bordered card around them read as a third panel to get past.
 */

import { injectCss } from '@/ui/cssInjector';

const CSS = `
.save-transfer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 520px;
}

.save-transfer-actions, .save-transfer-confirm-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.save-transfer-button {
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(242, 237, 227, 0.28);
  border-radius: 6px;
  background: rgba(242, 237, 227, 0.06);
  color: #f2ede3;
  font: inherit;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
}

.save-transfer-button:hover, .save-transfer-button:focus-visible {
  background: rgba(242, 237, 227, 0.16);
}

.save-transfer-button:disabled { opacity: 0.45; cursor: default; }

/* The one press that writes over a character, so it is the one press that is lit. */
.save-transfer-confirm {
  border-color: #e8b34a;
  background: rgba(232, 179, 74, 0.12);
  color: #e8b34a;
}

.save-transfer-confirm:hover, .save-transfer-confirm:focus-visible {
  background: rgba(232, 179, 74, 0.24);
}

.save-transfer-confirm-text {
  flex: 1 1 22ch;
  min-width: 0;
  font-size: clamp(11px, 3vw, 13px);
  color: #e8b34a;
}

.save-transfer-status {
  max-width: 60ch;
  margin: 0;
  padding: 8px 12px;
  border-left: 2px solid rgba(242, 237, 227, 0.28);
  background: rgba(242, 237, 227, 0.06);
  font-size: clamp(11px, 3vw, 13px);
  color: rgba(242, 237, 227, 0.82);
}

.save-transfer-bad {
  border-left-color: rgba(226, 112, 95, 0.7);
  background: rgba(226, 112, 95, 0.1);
}

.save-transfer-good {
  border-left-color: rgba(126, 190, 122, 0.7);
  background: rgba(126, 190, 122, 0.1);
}

.save-transfer-status.is-hidden, .save-transfer-confirm-row.is-hidden { display: none; }
`;

export function injectSaveTransferStyles(): () => void {
  return injectCss(CSS);
}
